module.exports = __webpack_public_path__ + "12c7ceff4702f83572209eda34503c22.pdf";